import React, { useState, useEffect } from 'react';
import Enumerable from 'linq';
import { format } from 'react-string-format';

//components material mui
import {
    Autocomplete,
    Grid,
    IconButton,
    Table,
    TableHead,
    TableContainer,
    TableBody,
    TextField,
    Tooltip,
    Typography,
} from '@mui/material';

//icons
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import StarIcon from '@mui/icons-material/Star';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

//config
import { enlistaArrayCodigosMensajesIdiomas } from '../../../../Actions/Generales/IdiomasAction';
import { MostrarMensaje } from '../../../../Utilidades/ManejoMensajes';
import { ValidarPropiedad } from '../../../../Utilidades/ValidarPropiedades';

//config home
import { MOBILE } from '../../config';

//hooks
import { useGlobalState } from '../../../../Utilidades/useGlobalState';

//components
import { SelectUbicacionNivel1 } from '../../../ControlUsuario/Ubicaciones/SelectUbicacionNivel1';
import { SelectUbicacionNivel2 } from '../../../ControlUsuario/Ubicaciones/SelectUbicacionNivel2';
import { SelectUbicacionNivel3 } from '../../../ControlUsuario/Ubicaciones/SelectUbicacionNivel3';
import { SelectUbicacionNivel4 } from '../../../ControlUsuario/Ubicaciones/SelectUbicacionNivel4';

import { ActionTitleAndButtons } from '../ActionTitleAndButtons'

import {
    ObtenerTablaRegistros,
    CrearNuevoRegistro,
    ActualizarRegistro,
    EliminarRegistro,
    EstablecerFavorito
} from '../../../../Actions/Clientes/ClientesDireccionesAction';

import {
    obtenerUbicaciones
} from '../../../../Actions/Companias/CompaniaUbicacionesAction';

//styles
import {
    styleTable,
    StyleHome
} from '../../../Tool/Style';

//styled component
import {
    StyledTableCellClass,
    StyledTableRowClass,
    StyledTableRowHeaderClass
} from '../../../../theme/themeTableRow';

/**
 *
 * @param {{ deviceIs: "DESKTOP" | "MOBILE" | "TABLET" }} param0
 * @returns
 */
function DireccionesClientes({ deviceIs = "DESKTOP", DatosContactoInfo }) {

    const { CodigoVerificado, ListCamposRequeridos, Credenciales, TipoDireccione, ListTiposDirecciones, ElimenarRegistro } = DatosContactoInfo;

    const [registro, setRegistro] = useState({ id: '00000000-0000-0000-0000-000000000000', text: '' });

    const [ubicacion1, setUbicacion1] = useState('00000000-0000-0000-0000-000000000000');
    const [ubicacion2, setUbicacion2] = useState('00000000-0000-0000-0000-000000000000');
    const [ubicacion3, setUbicacion3] = useState('00000000-0000-0000-0000-000000000000');
    const [ubicacion4, setUbicacion4] = useState('00000000-0000-0000-0000-000000000000');

    const { etiquetas, codigoIdioma, dispatch} = useGlobalState();

    const [Direccion, setDireccion] = useState({
        CustomerAddressId: '00000000-0000-0000-0000-000000000000',
        CustomerId: Credenciales.customerId,
        AddressTypeId: ListTiposDirecciones.length > 0 ? ListTiposDirecciones[0].id : '00000000-0000-0000-0000-000000000000',
        CuaPostalCode: '',
        CuaAddress: '',
        CompanyId: Credenciales.companyId,
        UserId: Credenciales.userId
    });

    const [listAddress, setListAddress] = useState([]); // se encarga del recolectar el listado de direcciones

    const [formLocation, setFormLocation] = useState({
        location1Dsc: '',
        location2Dsc: '',
        location3Dsc: '',
        location4Dsc: ''
    });

    useEffect(() => {
        LoadProperties();
    }, [codigoIdioma]);

    useEffect(() => {
        if (registro.id !== '00000000-0000-0000-0000-000000000000') {
            ElimenarRegistro(registro.text, eliminaAddress);
        }
    }, [registro]);

    useEffect(() => {
        getConfigLocation();
    }, [Credenciales.companyId]);

    const getConfigLocation = async () => {

        const dataFilter = {
            companyId: Credenciales.companyId,
            userId: Credenciales.userId,
        };

        const response = await obtenerUbicaciones(dataFilter);

        if (response.status === 200) {

            const {
                location1Dsc = '',
                location2Dsc = '',
                location3Dsc = '',
                location4Dsc = ''
            } = response.data;

            setFormLocation({
                location1Dsc: location1Dsc !== '' ? location1Dsc : etiquetas.InterfazClienteContactInfo.Et_tblProvince,
                location2Dsc: location2Dsc !== '' ? location2Dsc : etiquetas.InterfazClienteContactInfo.Et_tblCanton,
                location3Dsc: location3Dsc !== '' ? location3Dsc : etiquetas.InterfazClienteContactInfo.Et_tblDistrict,
                location4Dsc: location4Dsc !== '' ? location4Dsc : etiquetas.InterfazClienteContactInfo.Et_tblNeighborhood,
            });

        }
    };

    const LoadAddressTable = async () => {
        const objetoListar = {
            CustomerId: Credenciales.customerId,
            UserId: Credenciales.userId
        };
        const responseAddressTable = await ObtenerTablaRegistros(objetoListar);
        if (responseAddressTable.status === 200) //si la respuesta fue existosa
        {
            setListAddress(responseAddressTable.data);
        }
        else {
            if (responseAddressTable.data.errors) {
                const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responseAddressTable.data.errors);
                MostrarMensaje(dispatch, responseAddressTable.data.typeError, arrayErrores);
            } else {
                MostrarMensaje(dispatch, 'error', [responseAddressTable.statusText]);
            }
            setListAddress([]);
        }
    };

    const LoadProperties = async () => {
        await getConfigLocation();
        await LoadAddressTable();
    };

    const ingresarValoresMemoria = e => {
        const { name, value } = e.target;  // se desestructura del targen el nombre y el valor que trae

        // se usa el hook de useState sobre la variable de estado local y se actualiza solo la propiedad que concuerda con el
        // valor que se le envia lo demas se queda igual 
        setDireccion((anterior) => ({
            ...anterior,
            [name]: value
        }));
    };
    function salvarDireccion() {

        const objetoDireccion = {
            CustomerAddressId: Direccion.CustomerAddressId,
            CustomerId: Direccion.CustomerId,
            Province: ubicacion1,
            Ubication2Id: ubicacion2,
            Ubication3Id: ubicacion3,
            Ubication4Id: ubicacion4,
            AddressTypeId: Direccion.AddressTypeId,
            CuaPostalCode: Direccion.CuaPostalCode,
            CuaAddress: Direccion.CuaAddress,
            CompanyId: Credenciales.companyId,
            UserId: Credenciales.userId
        };

        let FiltroCamposRequeridos = ListCamposRequeridos.map(campo => {
            let campoTemp = campo;
            let campoDscEtiqueta = '';
            let codigoErrorCampo = '';
            if (campoTemp.code.toLowerCase() === 'Ubication1Id'.toLowerCase() || campoTemp.code.toLowerCase() === 'Ubication2Id'.toLowerCase()
                || campoTemp.code.toLowerCase() === 'Ubication3Id'.toLowerCase() || campoTemp.code.toLowerCase() === 'Ubication4Id'.toLowerCase()) {

            }

            switch (campoTemp.code.toLowerCase()) {
                case 'province'.toLowerCase(): //es la misma que Ubication1Id, pero de la base viene province
                    campoDscEtiqueta = textInputLocation(
                        'Ubication1Id',
                        etiquetas.InterfazClienteContactInfo.Et_tblProvince,
                        formLocation.city,
                        false
                    );
                    codigoErrorCampo = format(etiquetas?.General?.Et_ValidaCampoRequerido, campoDscEtiqueta);

                    break;
                case 'Ubication2Id'.toLowerCase():
                    campoDscEtiqueta = textInputLocation(
                        'Ubication2Id',
                        etiquetas.InterfazClienteContactInfo.Et_tblCanton,
                        formLocation.department,
                        false
                    );
                    codigoErrorCampo = format(etiquetas?.General?.Et_ValidaCampoRequerido, campoDscEtiqueta);

                    break;
                case 'Ubication3Id'.toLowerCase():
                    campoDscEtiqueta = textInputLocation(
                        'Ubication3Id',
                        etiquetas.InterfazClienteContactInfo.Et_tblDistrict,
                        formLocation.municipality,
                        false
                    );
                    codigoErrorCampo = format(etiquetas?.General?.Et_ValidaCampoRequerido, campoDscEtiqueta);

                    break;
                case 'Ubication4Id'.toLowerCase():
                    campoDscEtiqueta = textInputLocation(
                        'Ubication4Id',
                        etiquetas.InterfazClienteContactInfo.Et_tblNeighborhood,
                        formLocation.neighborhood,
                        false
                    );
                    codigoErrorCampo = format(etiquetas?.General?.Et_ValidaCampoRequerido, campoDscEtiqueta);

                    break;
                default:
                    codigoErrorCampo = campoTemp.codeError;
                    break;
            }
            campoTemp.codeError = codigoErrorCampo;
            return campoTemp;
        });

        const validacionCampos = ValidarPropiedad(FiltroCamposRequeridos, objetoDireccion, dispatch);

        if (validacionCampos) {
            dispatch({ type: "LOAD_CLIENT", texto: etiquetas.CargandoModal.Et_Procesando });
            if (Direccion.CustomerAddressId !== '00000000-0000-0000-0000-000000000000') {
                ActualizarRegistro(objetoDireccion).then(response => {
                    if (response.status === 200) //si la respuesta fue existosa 
                    {
                        LoadAddressTable();
                        NuevaDireccion();
                        MostrarMensaje(dispatch, 'success', ["updateOk"]);
                    }
                    else {
                        if (response.data.errors) {
                            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                            MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                        } else {
                            MostrarMensaje(dispatch, 'error', [response.statusText]);
                        }
                    }
                });
                dispatch({ type: "CLOSE_LOAD_CLIENT" });
            }
            else {
                CrearNuevoRegistro(objetoDireccion).then(response => {
                    if (response.status === 200) //si la respuesta fue existosa 
                    {
                        LoadAddressTable();
                        NuevaDireccion();
                        MostrarMensaje(dispatch, 'success', ["insertOk"]);
                    }
                    else {
                        if (response.data.errors) {
                            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                            MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                        } else {
                            MostrarMensaje(dispatch, 'error', [response.statusText]);
                        }
                    }
                });
                dispatch({ type: "CLOSE_LOAD_CLIENT" });
            }
        }
    };

    async function NuevaDireccion() {

        setUbicacion1('00000000-0000-0000-0000-000000000000');

        setDireccion({
            CustomerAddressId: '00000000-0000-0000-0000-000000000000',
            CustomerId: Credenciales.customerId,
            AddressTypeId: ListadoAddressType.length > 0 ? ListadoAddressType[0].id : '00000000-0000-0000-0000-000000000000',
            CuaPostalCode: '',
            CuaAddress: '',
            CompanyId: Credenciales.companyId,
            UserId: Credenciales.userId
        });

        TipoDireccione.SetInfo(ListTiposDirecciones.length > 0 ? { id: ListTiposDirecciones[0].id, description: ListTiposDirecciones[0].description } : { id: '00000000-0000-0000-0000-000000000000', description: '' });
    };

    async function EditarDireccion(direccion) {

        setUbicacion1(direccion.locId1);
        setUbicacion2(direccion.locId2);
        setUbicacion3(direccion.locId3);
        setUbicacion4(direccion.locId4);

        setDireccion({
            CustomerAddressId: direccion.cuaCustomerAddressId,
            CustomerId: Credenciales.customerId,
            AddressTypeId: direccion.cuaAddressTypeIdFk,
            CuaPostalCode: direccion.cuaPostalCode,
            CuaAddress: direccion.cuaAddress,
            CompanyId: Credenciales.companyId,
            UserId: Credenciales.userId
        });

        const tipoTemp = Enumerable.from(ListTiposDirecciones).firstOrDefault(x => x.id === direccion.cuaAddressTypeIdFk);
        TipoDireccione.SetInfo(ListTiposDirecciones.length > 0 && tipoTemp !== undefined ? tipoTemp : { id: '00000000-0000-0000-0000-000000000000', description: '' });
    };

    function EditarDireccionFavorito(direccion) {

        const objetoFavorito = {
            CustomerAddressId: direccion.cuaCustomerAddressId,
            CustomerId: Credenciales.customerId,
            CompanyId: Credenciales.companyId,
            UserId: Credenciales.userId
        };

        EstablecerFavorito(objetoFavorito).then(response => {
            if (response.status === 200) //si la respuesta fue existosa 
            {
                LoadAddressTable();
                NuevaDireccion();
            }
            else {
                if (response.data.errors) {
                    const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                    MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                } else {
                    MostrarMensaje(dispatch, 'error', [response.statusText]);
                }
            }
        });
    };

    const eliminaAddress = async () => {
        const objetoEliminar = {
            CustomerAddressId: registro.id,
            CompanyId: Credenciales.companyId,
            UserId: Credenciales.userId
        };

        EliminarRegistro(objetoEliminar).then(response => {
            if (response.status === 200) //si la respuesta fue existosa 
            {
                MostrarMensaje(dispatch, 'success', ["deleteOk"]);
                NuevaDireccion();
                LoadAddressTable();
            }
            else {
                if (response.data.errors) {
                    const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                    MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                } else {
                    MostrarMensaje(dispatch, 'error', [response.statusText]);
                }
            }
            ElimenarRegistro('', null);
        });
    };

    function ManejadorTipoDireccion(id) {
        setDireccion((anterior) => ({
            ...anterior,
            AddressTypeId: id
        }));
    };

    const ingresarValoresMemoriaAuto = (event, newValue) => {
        if (newValue === null || newValue === undefined || newValue === '') {
            TipoDireccione.SetInfo({ id: '00000000-0000-0000-0000-000000000000', description: '' });
            ManejadorTipoDireccion('00000000-0000-0000-0000-000000000000');
        } else {
            TipoDireccione.SetInfo(newValue);
            ManejadorTipoDireccion(newValue.id);
        }
    };

    const textInputLocation = (code = '', labelDictionary = '', locationText = '', setObligatorio = true) => {

        const isExist = ListCamposRequeridos.some(x => x.code === code);

        let obligatorio = '';

        if (isExist && setObligatorio) {

            obligatorio = obligatorio + ' *'

        }

        return locationText === '' ? (labelDictionary + obligatorio) : (locationText + obligatorio)

    }

    return (
        <React.Fragment>

            <ActionTitleAndButtons  
             deviceIs={deviceIs}
             titleOption={etiquetas.InterfazClienteContactInfo.Et_tblAddress}
             cleanClick={NuevaDireccion}
             saveClick={salvarDireccion}
             CodigoVerificado={CodigoVerificado} />

            <div>
                <Grid key='GridAddresInformation' container style={deviceIs == MOBILE ? { backgroundColor:'#fff' } : StyleHome.GridConteiner} >
                    <Grid item xs={deviceIs == MOBILE ? 12 : 6} sm={6} md={6} style={StyleHome.GridItem}>
                        <Autocomplete
                            disabled={CodigoVerificado === false}
                            noOptionsText={etiquetas.General.Et_tblSinOpciones}
                            fullWidth
                            value={TipoDireccione.Info}
                            name='TipoDireccione'
                            options={ListTiposDirecciones}
                            onChange={ingresarValoresMemoriaAuto}
                            getOptionLabel={(option) => option.description}
                            renderInput={(params) => <TextField name='label' {...params} label=
                                {Enumerable.from(ListCamposRequeridos).any(x => x.code === 'AddressTypeId') ?
                                    etiquetas.InterfazClienteContactInfo.Et_tblAddressType + ' *' :
                                    etiquetas.InterfazClienteContactInfo.Et_tblAddressType
                                } />}
                        />
                    </Grid>
                    <Grid item xs={deviceIs == MOBILE ? 12 : 6} sm={6} md={6} style={StyleHome.GridItem}>
                        <TextField
                            disabled={CodigoVerificado === false}
                            name="CuaPostalCode"
                            value={Direccion.CuaPostalCode}
                            variant="outlined"
                            fullWidth
                            label={Enumerable.from(ListCamposRequeridos).any(x => x.code === 'CuaPostalCode') ?
                                etiquetas.InterfazClienteContactInfo.Et_tblPostalCode + ' *' :
                                etiquetas.InterfazClienteContactInfo.Et_tblPostalCode
                            }
                            onChange={ingresarValoresMemoria}
                            inputProps={{
                                maxLength: 20
                            }}>
                        </TextField>
                    </Grid>
                    <Grid item xs={deviceIs == MOBILE ? 12 : 6} sm={6} md={6} style={StyleHome.GridItem}>
                        <SelectUbicacionNivel1
                            textLabel={
                                textInputLocation(
                                    'province',
                                    etiquetas.InterfazClienteContactInfo.Et_tblProvince,
                                    formLocation.location1Dsc
                                )
                            }
                            textSinOpciones={etiquetas.General.Et_tblSinOpciones}
                            testSeleccione={etiquetas.General.Et_Select}
                            setIdElemento={setUbicacion1}
                            idElemento={ubicacion1}
                            sesionUsuario={{ usuario: { companyId: Credenciales.companyId, userId: Credenciales.userId } }}
                            dispatch={dispatch}
                        />
                    </Grid>
                    <Grid item xs={deviceIs == MOBILE ? 12 : 6} sm={6} md={6} style={StyleHome.GridItem}>
                        <SelectUbicacionNivel2
                            textLabel={
                                textInputLocation(
                                    'Ubication2Id',
                                    etiquetas.InterfazClienteContactInfo.Et_tblCanton,
                                    formLocation.location2Dsc
                                )
                            }
                            textSinOpciones={etiquetas.General.Et_tblSinOpciones}
                            testSeleccione={etiquetas.General.Et_Select}
                            setIdElemento={setUbicacion2}
                            idElemento={ubicacion2}
                            idElementoPadre={ubicacion1}
                            sesionUsuario={{ usuario: { companyId: Credenciales.companyId, userId: Credenciales.userId } }}
                            dispatch={dispatch}
                        />
                    </Grid>
                    <Grid item xs={deviceIs == MOBILE ? 12 : 6} sm={6} md={6} style={StyleHome.GridItem}>
                        <SelectUbicacionNivel3
                            textLabel={
                                textInputLocation(
                                    'Ubication3Id',
                                    etiquetas.InterfazClienteContactInfo.Et_tblDistrict,
                                    formLocation.location3Dsc
                                )
                            }
                            textSinOpciones={etiquetas.General.Et_tblSinOpciones}
                            testSeleccione={etiquetas.General.Et_Select}
                            setIdElemento={setUbicacion3}
                            idElemento={ubicacion3}
                            idElementoPadre={ubicacion2}
                            sesionUsuario={{ usuario: { companyId: Credenciales.companyId, userId: Credenciales.userId } }}
                            dispatch={dispatch}
                        />
                    </Grid>
                    <Grid item xs={deviceIs == MOBILE ? 12 : 6} sm={6} md={6} style={StyleHome.GridItem}>
                        <SelectUbicacionNivel4
                            textLabel={
                                textInputLocation(
                                    'Ubication4Id',
                                    etiquetas.InterfazClienteContactInfo.Et_tblNeighborhood,
                                    formLocation.location4Dsc
                                )
                            }
                            textSinOpciones={etiquetas.General.Et_tblSinOpciones}
                            testSeleccione={etiquetas.General.Et_Select}
                            setIdElemento={setUbicacion4}
                            idElemento={ubicacion4}
                            idElementoPadre={ubicacion3}
                            sesionUsuario={{ usuario: { companyId: Credenciales.companyId, userId: Credenciales.userId } }}
                            dispatch={dispatch}
                        />
                    </Grid>
                    <Grid item xs={deviceIs == MOBILE ? 12 : 6} sm={12} md={12} style={StyleHome.GridItem}>
                        <TextField
                            disabled={CodigoVerificado === false}
                            multiline
                            name="CuaAddress"
                            value={Direccion.CuaAddress}
                            variant="outlined"
                            fullWidth
                            rows={2}
                            label={Enumerable.from(ListCamposRequeridos).any(x => x.code === 'Ubication4Id') ?
                                etiquetas.InterfazClienteContactInfo.Et_tblExactAdress + ' *' :
                                etiquetas.InterfazClienteContactInfo.Et_tblExactAdress
                            }
                            onChange={ingresarValoresMemoria}
                            inputProps={{
                                maxLength: 200
                            }}>
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} style={StyleHome.GridItem}>
                        
                     { deviceIs === MOBILE ?
                     
                       <div  style={{display:'flex', flexDirection:'column'}}>
                            {listAddress.length > 0 ? listAddress.map((registro) => (
                                <div key={registro.cuaCustomerAddressId + 'mobile'}>
                                <div  style={{display:'flex', justifyContent:'space-between'}}>
                                   
                                   <Typography sx={StyleHome.textPrimary}>
                                        {etiquetas.InterfazClienteContactInfo.Et_tblAddressType}:
                                   </Typography>

                                   <Typography sx={StyleHome.textSecondary}>
                                      {registro.addDsc}
                                    </Typography>

                                </div>

                                <div  style={{display:'flex', justifyContent:'space-between'}}>
                                   
                                   <Typography sx={StyleHome.textPrimary}>
                                        {etiquetas.InterfazClienteContactInfo.Et_tblPostalCode}:
                                   </Typography>

                                   <Typography sx={StyleHome.textSecondary}>
                                      {registro.cuaPostalCode}
                                    </Typography>

                                </div>

                                <div style={{display:'flex', justifyContent:'space-between'}}>
                                   
                                   <Typography sx={StyleHome.textPrimary}>
                                        { textInputLocation(
                                                'province',
                                                etiquetas.InterfazClienteContactInfo.Et_tblProvince,
                                                formLocation.location1Dsc,
                                                false
                                            )}:
                                   </Typography>

                                   <Typography sx={StyleHome.textSecondary}>
                                      {registro.locName1}
                                    </Typography>

                                </div>

                                <div style={{display:'flex', justifyContent:'space-between'}}>
                                   
                                   <Typography sx={StyleHome.textPrimary}>
                                        {  textInputLocation(
                                                'Ubication2Id',
                                                etiquetas.InterfazClienteContactInfo.Et_tblCanton,
                                                formLocation.location2Dsc,
                                                false
                                            )}:
                                   </Typography>

                                   <Typography sx={StyleHome.textSecondary}>
                                      {registro.locName2}
                                    </Typography>

                                </div>

                                <div style={{display:'flex', justifyContent:'space-between'}}>
                                   
                                   <Typography sx={StyleHome.textPrimary}>
                                        {etiquetas.InterfazClienteContactInfo.Et_tblExactAdress}:
                                   </Typography>

                                   <Typography sx={StyleHome.textSecondary}>
                                      {registro.cuaAddress}
                                    </Typography>

                                </div>

                                <div style={{display:'flex', justifyContent:'space-between'}}>
                                   
                                   <Typography sx={StyleHome.textPrimary}>
                                        {etiquetas.General.Et_tblAcciones}:
                                   </Typography>

                                   <IconButton style={styleTable.BodyButtoms}
                                    disabled={/*CodigoVerificado === false*/false}
                                    onClick={() => {
                                        setRegistro({ id: registro.cuaCustomerAddressId, text: registro.cuaAddress });
                                    }}>
                                    <DeleteIcon fontSize="normal" />
                                </IconButton>

                                </div>

                                </div>
                            )):null}
                       </div>

                      :
                        <TableContainer component={Grid} style={styleTable.TableConteiner}>
                            <Table stickyHeader>
                                <TableHead style={styleTable.TableHeader}>
                                    <StyledTableRowHeaderClass>
                                        <StyledTableCellClass width='18%'>{etiquetas.InterfazClienteContactInfo.Et_tblAddressType}</StyledTableCellClass>
                                        <StyledTableCellClass width='10%'>{etiquetas.InterfazClienteContactInfo.Et_tblPostalCode}</StyledTableCellClass>
                                        <StyledTableCellClass width='16%'>{
                                            textInputLocation(
                                                'province',
                                                etiquetas.InterfazClienteContactInfo.Et_tblProvince,
                                                formLocation.location1Dsc,
                                                false
                                            )
                                        }</StyledTableCellClass>
                                        <StyledTableCellClass width='16%'>{
                                            textInputLocation(
                                                'Ubication2Id',
                                                etiquetas.InterfazClienteContactInfo.Et_tblCanton,
                                                formLocation.location2Dsc,
                                                false
                                            )
                                        }</StyledTableCellClass>
                                        <StyledTableCellClass width='30%'>{etiquetas.InterfazClienteContactInfo.Et_tblExactAdress}</StyledTableCellClass>
                                        <StyledTableCellClass width='10%' Align='center'>{etiquetas.General.Et_tblAcciones}</StyledTableCellClass>
                                    </StyledTableRowHeaderClass>
                                </TableHead>
                                <TableBody>
                                    {listAddress.length > 0 ? listAddress.map((registro) => (
                                        <StyledTableRowClass key={registro.cuaCustomerAddressId}>
                                            <StyledTableCellClass width='18%' component="th" scope="row">{registro.addDsc}</StyledTableCellClass>
                                            <StyledTableCellClass width='10%'>{registro.cuaPostalCode}</StyledTableCellClass>
                                            <StyledTableCellClass width='16%'>{registro.locName1}</StyledTableCellClass>
                                            <StyledTableCellClass width='16%'>{registro.locName2}</StyledTableCellClass>
                                            <StyledTableCellClass width='30%'>{registro.cuaAddress}</StyledTableCellClass>
                                            <StyledTableCellClass width='10%' Align='center'>
                                                <div style={styleTable.BodyContainerButtoms}>
                                                    <Tooltip title={etiquetas.General.Et_tbnFavorito}>
                                                        <IconButton style={styleTable.BodyButtoms}
                                                            disabled={CodigoVerificado === false}
                                                            onClick={() => {
                                                                if (registro.cuaFavorite === false)
                                                                    EditarDireccionFavorito(registro);
                                                            }}>
                                                            {registro.cuaFavorite === false ?
                                                                <StarBorderOutlinedIcon fontSize="normal" />
                                                                :
                                                                <StarIcon fontSize="normal" />
                                                            }
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title={etiquetas.General.Et_tbnEditar}>
                                                        <IconButton style={styleTable.BodyButtoms}
                                                            disabled={CodigoVerificado === false}
                                                            onClick={() => EditarDireccion(registro)}>
                                                            <EditIcon fontSize="normal" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title={etiquetas.General.Et_tbnEliminar}>
                                                        <IconButton style={styleTable.BodyButtoms}
                                                            disabled={CodigoVerificado === false}
                                                            onClick={() => {
                                                                setRegistro({ id: registro.cuaCustomerAddressId, text: registro.cuaAddress });
                                                            }}>
                                                            <DeleteIcon fontSize="normal" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                            </StyledTableCellClass>
                                        </StyledTableRowClass>
                                    )) : <StyledTableRowClass>
                                        <StyledTableCellClass colSpan={6}>{etiquetas.General.Et_tblTableEmty}</StyledTableCellClass>
                                    </StyledTableRowClass>}
                                </TableBody>
                            </Table>
                        </TableContainer> 
                      }

                    </Grid>
                </Grid>
            </div>
        </React.Fragment>
    );
};

export default DireccionesClientes;